

































import {
  Vue, Prop, Component, Emit,
} from 'vue-property-decorator';
import LabelSlot from '@/shared/slots/label-slot.component.vue';
import Customer from '@/domain/customer/entity/customer.entity';
import Pagination from '@/domain/pagination.entity';
import CustomerService from '@/domain/customer/service/customer.service';
import customerOptions from './customer-options.json';

@Component({
  components: {
    'label-slot': LabelSlot,
  },
})
export default class CustomerPickerComponent extends Vue {
  @Prop({
    required: true,
    default: '',
  })
  private businessUnitId!: string;

  selectedCustomerOption: string = '';

  lastFilteredName: string = '';

  customerFetch: string = '';

  customers: Array<Customer> = [];

  customerId: string = '';

  pagination: Pagination = new Pagination({
    page: 0,
    itemsPerPage: 100,
    defaultSort: 'name|asc',
  });

  customerOptions = customerOptions;

  created() {
    this.getCustomers(this.customerFetch);
  }

  get customerItemText() {
    return this.selectedCustomerOption === 'tradingName'
      ? 'tradingName' : 'name';
  }

  @Emit('customerSelected')
  customerSelected() {
    return this.customerId;
  }

  getCustomers(name: string) {
    if (name && name.length >= 3 && name !== this.lastFilteredName) {
      this.lastFilteredName = name;
      CustomerService.getByTradingNameOrName(this.pagination, name,
        this.selectedCustomerOption, this.businessUnitId)
        .then((response: any) => {
          this.customers = Customer.ofList(response.content)
        });
    }
  }
}
